module.exports = __webpack_public_path__ + "img/hero-beetle-ant-mtn.cc8f390f.png";